module.exports = __webpack_public_path__ + "img/f6-05.bfd9c00f.png";